import { Box, Card, styled } from '@mui/material';

interface DisplayPictureBoxProps {
  scrolled?: string;
}

interface FamilyDisplayPictureBoxProps extends DisplayPictureBoxProps {
  fixed?: string;
}

export const DisplayPictureBoxStyled = styled(Card)<DisplayPictureBoxProps>(
  ({ theme, scrolled }) => ({
    margin: theme.spacing(8, 5),
    // height: '90%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxShadow: 'none',
    zIndex: 1030,
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto',
      position: scrolled === 'true' ? 'fixed' : 'relative',
      left: 0,
      top: scrolled === 'true' ? '75px' : '',
      padding: theme.spacing(6, 0),
      width: scrolled === 'true' ? '100vw' : '',
      boxShadow:
        scrolled === 'true'
          ? '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
          : 'none',
    },
  })
);

export const FamilyDisplayPictureBoxStyled = styled(
  Card
)<FamilyDisplayPictureBoxProps>(({ theme, scrolled, fixed }) => ({
  margin: scrolled === 'true' ? theme.spacing(8, 0) : theme.spacing(8, 5),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  boxShadow: 'none',
  position: fixed === 'true' ? 'fixed' : 'relative',
  top: fixed === 'true' ? '49.2px' : '',
  paddingBottom: fixed === 'true' ? '2rem' : '',
  borderBottom: fixed === 'true' ? '1px solid rgba(0,0,0,0.12)' : '',
  zIndex: scrolled === 'true' ? 1 : '',
  width: scrolled === 'true' ? '328px' : '288px',
}));

export const DisplayPicturePaper = styled(Box)<DisplayPictureBoxProps>`
  margin-top: scrolled === 'true' ? 1rem : 3rem;
`;

export const CropContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '18.4rem',
  marginBottom: theme.spacing(4),
}));

export const InputFileBox = styled('input')({
  opacity: 0,
  display: 'block',
  position: 'absolute',
  height: '100%',
  width: '100%',
  top: 0,
  left: 0,
});
